import React, { useRef, useState, useEffect } from "react";
import "./PoppupWIndow.css";
import axios from "axios";

const PopupWindow = ({
  isOpen,
  onClose,
  onSave,
  initialContent1,
  initialContent2,
  initialContent3,
  url,
}) => {
  const textAreaRef1 = useRef(null);
  const textAreaRef2 = useRef(null);
  const textAreaRef3 = useRef(null);

  // 添加 temperature 状态
  const [temperature1, setTemperature1] = useState(0.8); // Blog Prompt 默认值
  const [temperature2, setTemperature2] = useState(0.8); // KB Prompt 默认值
  const [temperature3, setTemperature3] = useState(0.8); // Review Prompt 默认值

  const [blogContent, setBlogContent] = useState("");
  const [kbContent, setKbContent] = useState("");
  const [reviewContent, setReviewContent] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setBlogContent(initialContent1);
      setKbContent(initialContent2);
      setReviewContent(initialContent3);
    }
  }, [isOpen, initialContent1, initialContent2, initialContent3, url]);

  const handleSave = () => {
    let newText1 = textAreaRef1.current ? textAreaRef1.current.value : "";
    let newText2 = textAreaRef2.current ? textAreaRef2.current.value : "";
    let newText3 = textAreaRef3.current ? textAreaRef3.current.value : "";

    // 将 content 和 temperature 一起保存
    onSave({
      prompt1: { content: newText1, temperature: temperature1 },
      prompt2: { content: newText2, temperature: temperature2 },
      prompt3: { content: newText3, temperature: temperature3 },
    });

    onClose();
  };

  const refreshPromptData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(url);
      if (response.status === 200) {
        setBlogContent(response.data.blogPrompt);
        setKbContent(response.data.kbPrompt);
        setReviewContent(response.data.reviewPrompt);
      } else {
        console.log("Failed to fetch new prompts");
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Edit Content</h2>
        <p>Remember to <strong>SAVE</strong> the prompt after making changes.</p>

        <div className="textarea-container">
          <div className="textarea-item">
            <h5>Blog Prompt:</h5>
            <textarea
              ref={textAreaRef1}
              value={blogContent}
              onChange={(e) => setBlogContent(e.target.value)}
              className="edit-textarea"
              rows={10}
              cols={40}
            />
            <label>
              Temperature:
              <input
                type="number"
                step="0.1"
                min="0"
                max="2"
                value={temperature1}
                onChange={(e) => setTemperature1(parseFloat(e.target.value))}
              />
            </label>
          </div>

          <div className="textarea-item">
            <h5>Knowledge Base Prompt:</h5>
            <textarea
              ref={textAreaRef2}
              value={kbContent}
              onChange={(e) => setKbContent(e.target.value)}
              className="edit-textarea"
              rows={10}
              cols={40}
            />
            <label>
              Temperature:
              <input
                type="number"
                step="0.1"
                min="0"
                max="2"
                value={temperature2}
                onChange={(e) => setTemperature2(parseFloat(e.target.value))}
              />
            </label>
          </div>

          <div className="textarea-item">
            <h5>Review Prompt:</h5>
            <textarea
              ref={textAreaRef3}
              value={reviewContent}
              onChange={(e) => setReviewContent(e.target.value)}
              className="edit-textarea"
              rows={10}
              cols={40}
            />
            <label>
              Temperature:
              <input
                type="number"
                step="0.1"
                min="0"
                max="2"
                value={temperature3}
                onChange={(e) => setTemperature3(parseFloat(e.target.value))}
              />
            </label>
          </div>
        </div>

        <div className="button-group">
          <button onClick={handleSave}>Save</button>
          <button onClick={refreshPromptData} disabled={loading}>
            {loading ? "Fetching..." : "Get Live Prompt"}
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default PopupWindow;
